import React from 'react';
import { Link } from 'react-router-dom';
import MinimalHeader from './MinimalHeader';
import '../styles/tab-navigation.css';
import '../styles/components/AppLayout.css';

/**
 * AppLayout - アプリ共通レイアウト
 * ヘッダーを自動で配置（タブナビはApp.jsで全ページ共通）
 *
 * @param {React.ReactNode} children - ページコンテンツ
 * @param {React.ReactNode} actionButton - ヘッダー右側のアクションボタン（任意）
 * @param {boolean} showMenu - ハンバーガーメニューを表示するか（デフォルト: true）
 * @param {boolean} showFooter - フッターを表示するか（デフォルト: true）
 */
const AppLayout = ({
  children,
  actionButton = null,
  showMenu = true,
  showFooter = true
}) => {
  return (
    <div className="app-layout">
      {/* グローバルヘッダー */}
      <div className="app-layout__header">
        <MinimalHeader actionButton={actionButton} showMenu={showMenu} />
      </div>

      {/* コンテンツエリア */}
      <div className="app-layout__content">
        {children}

        {/* Legal Footer - フッターはcontent内に配置（app-layoutがoverflow:hiddenのため） */}
        {showFooter && (
          <footer className="app-layout__footer">
            <div className="app-layout__footer-container">
              <p className="app-layout__footer-disclaimer">
                ⚠️ 本サービスは医療行為ではありません。診断・治療が必要な場合は必ず医療機関を受診してください。
              </p>
              <p className="app-layout__footer-copyright">
                © 2026 はしもと栄養パートナー. All rights reserved.
              </p>
              <div className="app-layout__footer-links">
                <Link to="/terms" className="app-layout__footer-link">
                  利用規約
                </Link>
                <Link to="/privacy" className="app-layout__footer-link">
                  プライバシーポリシー
                </Link>
                <Link to="/commercial-law" className="app-layout__footer-link">
                  特定商取引法に基づく表記
                </Link>
                <Link to="/faq" className="app-layout__footer-link">
                  よくある質問
                </Link>
                <Link to="/how-to-use" className="app-layout__footer-link">
                  使い方ガイド
                </Link>
              </div>
            </div>
          </footer>
        )}
      </div>
    </div>
  );
};

export default AppLayout;
